{
  "{account} needs to sign in again.": "{account} må logge inn igjen.",
  "{account} no longer has access to Johku Hub.": "{account} har ikke lenger tilgang til Johku Hub.",
  "{done} of {total}": "{done} av {total}",
  "{left} of {total} left": "{left} av {total} igjen",
  "{n} by email": "{n} på e-post",
  "{n} by push": "{n} som varsel",
  "{n} customer waiting for a reply": "{n} kunde venter på svar",
  "{n} customers waiting for a reply": "{n} kunder venter på svar",
  "{n} let in on this phone": "{n} sluppet inn med denne telefonen",
  "{n} message": "{n} melding",
  "{n} message hasn't been sent yet and will be lost.": "{n} melding er ikke sendt ennå og går tapt.",
  "{n} messages": "{n} meldinger",
  "{n} messages haven't been sent yet and will be lost.": "{n} meldinger er ikke sendt ennå og går tapt.",
  "{n} more: search by name.": "{n} til: søk etter navn.",
  "{n} of {total}": "{n} av {total}",
  "{n} pcs": "{n} stk.",
  "{n} shop chosen": "{n} butikk valgt",
  "{n} shops chosen": "{n} butikker valgt",
  "{n} ticket": "{n} billett",
  "{n} tickets": "{n} billetter",
  "{n} unread": "{n} uleste",
  "{n} unread conversation": "{n} ulest samtale",
  "{n} unread conversations": "{n} uleste samtaler",
  "{n} use left": "{n} bruk igjen",
  "{n} uses left": "{n} bruk igjen",
  "{name} ({n} member)": "{name} ({n} medlem)",
  "{name} ({n} members)": "{name} ({n} medlemmer)",
  "{name} and {n} more": "{name} og {n} til",
  "{name} sent you a message in Johku Hub ({subject}).": "{name} sendte deg en melding i Johku Hub ({subject}).",
  "{name} sent you a message in Johku Hub.": "{name} sendte deg en melding i Johku Hub.",
  "{shop} can sell its products in your sales channel. Once they accept, Johku puts it into effect.": "{shop} kan selge produktene sine i salgskanalen din. Når de godtar, tar Johku det i bruk.",
  "{shop} sent you a message about your order {order}.": "{shop} sendte deg en melding om bestillingen din {order}.",
  "{shop} would like to talk with you. Reply or accept to continue.": "{shop} vil snakke med dere. Svar eller godta for å fortsette.",
  "{sold} of {seats} sold": "{sold} av {seats} solgt",
  "{used} of {total} let in": "{used} av {total} sluppet inn",
  "A Bluetooth or USB scanner that types the code, as in the POS's ticket reader.": "En Bluetooth- eller USB-skanner som skriver inn koden, som i kassens billettleser.",
  "About Johku": "Om Johku",
  "Accept": "Godta",
  "Accepted the offer: {channel}, {commission} % commission.": "Godtok tilbudet: {channel}, {commission} % provisjon.",
  "Accepted, being put into effect in Johku": "Godtatt, tas i bruk i Johku",
  "Accepted, but Johku couldn't put it into effect: {error}": "Godtatt, men Johku kunne ikke ta det i bruk: {error}",
  "Accepted, in effect in Johku": "Godtatt, i bruk i Johku",
  "Access and instructions": "Tilgangs- og bruksinstruksjoner",
  "Accounts": "Kontoer",
  "Accounts and settings": "Kontoer og innstillinger",
  "Add account": "Legg til konto",
  "Add an account": "Legg til en konto",
  "All": "Alle",
  "All caught up": "Alt er lest",
  "All incidents": "Alle driftsforstyrrelser",
  "All orders": "Alle bestillinger",
  "All shops": "Alle butikker",
  "All your shops ({n})": "Alle butikkene dine ({n})",
  "Allow": "Tillat",
  "Allow {app} to use Johku Hub?": "Gi {app} tilgang til Johku Hub?",
  "Already used": "Allerede brukt",
  "an assistant": "en assistent",
  "An assistant asks to use your Johku Hub conversations. Sign in first.": "En assistent ber om tilgang til samtalene dine i Johku Hub. Logg inn først.",
  "As {name}": "Som {name}",
  "Ask the shop": "Spør butikken",
  "Attach a file": "Legg ved en fil",
  "Back": "Tilbake",
  "Between organisations": "Mellom organisasjoner",
  "Booking": "Reservasjon",
  "Can't load the collections right now.": "Samlingene kan ikke lastes akkurat nå.",
  "Can't load the list of organisations right now.": "Listen over organisasjoner kan ikke lastes akkurat nå.",
  "Can't reach Johku Hub. Check your connection and try again.": "Får ikke kontakt med Johku Hub. Sjekk tilkoblingen og prøv igjen.",
  "Cancel": "Avbryt",
  "Cancelled": "Avbestilt",
  "Cause found, being fixed": "Årsaken er funnet, rettes",
  "Check in": "Sjekk inn",
  "Check out": "Sjekk ut",
  "Check-in opens {time}.": "Innsjekking åpner {time}.",
  "Checked in {time}": "Sjekket inn {time}",
  "Checked out {time}": "Sjekket ut {time}",
  "Checking in…": "Sjekker inn…",
  "Checking out…": "Sjekker ut…",
  "Checking the ticket…": "Sjekker billetten…",
  "Choose a conversation": "Velg en samtale",
  "Choose resources and start times": "Velg ressurser og starttider",
  "Choose the seats to let in": "Velg plassene som slippes inn",
  "Choose the shows to scan for": "Velg forestillingene du skanner for",
  "Chosen shops": "Valgte butikker",
  "Close": "Lukk",
  "Code sent to {email}": "Kode sendt til {email}",
  "Codes": "Koder",
  "Commission (%)": "Provisjon (%)",
  "Confirmed": "Bekreftet",
  "Conversation": "Samtale",
  "Conversation with the shop": "Samtale med butikken",
  "Conversations with the Johku team and shops show up here.": "Samtaler med Johku-teamet og butikker vises her.",
  "Copied": "Kopiert",
  "Copy the code": "Kopier koden",
  "customer": "kunde",
  "Customer": "Kunde",
  "Decline": "Avslå",
  "Declined": "Avslått",
  "Declined the offer.": "Avslo tilbudet.",
  "Deny": "Avslå",
  "Done": "Ferdig",
  "Download": "Last ned",
  "Downloading {name}": "Laster ned {name}",
  "E.g. Card payments fail": "F.eks. Kortbetalinger feiler",
  "Each member gets it in a conversation of their own with the shop, and their replies come to you one by one.": "Hvert medlem får den i en egen samtale med butikken, og svarene deres kommer til deg ett og ett.",
  "Email address": "E-postadresse",
  "Email those who don't have the app": "Send e-post til dem som ikke har appen",
  "Event times, cancellations and the shop's replies.": "Tidspunkter for arrangementer, avlysninger og butikkens svar.",
  "Every shop": "Alle butikker",
  "Everything you've bought from Johku shops, in one place.": "Alt du har kjøpt i Johku-butikker, på ett sted.",
  "Expired {date}": "Utløp {date}",
  "Find a shop": "Finn butikk",
  "Fixed, monitoring": "Rettet, følges med",
  "For": "Til",
  "For every shop": "Til alle butikker",
  "For: {shops}": "Til: {shops}",
  "Get started": "Kom i gang",
  "Get told about new messages": "Bli varslet om nye meldinger",
  "Getting the shows…": "Henter forestillingene…",
  "Getting the tickets…": "Henter billettene…",
  "Gift cards and other codes you buy from Johku shops show up here.": "Gavekort og andre koder du kjøper i Johku-butikker, vises her.",
  "Hide": "Skjul",
  "Hide used and expired codes": "Skjul brukte og utløpte koder",
  "Home": "Hjem",
  "Hub may not use the camera. Allow it in the phone's settings.": "Hub har ikke tilgang til kameraet. Tillat det i telefonens innstillinger.",
  "In messages": "I meldinger",
  "Incidents": "Driftsforstyrrelser",
  "Incidents in Johku": "Driftsforstyrrelser i Johku",
  "Investigating": "Undersøkes",
  "It is valid for 10 minutes. If you didn't ask for it, you can ignore this email.": "Den er gyldig i 10 minutter. Hvis du ikke ba om den, kan du se bort fra denne e-posten.",
  "It opens signed in, and stays open in the background": "Den åpnes innlogget og holder seg åpen i bakgrunnen",
  "It sees only what you see in Johku Hub, and every use is logged.": "Den ser bare det du ser i Johku Hub, og all bruk logges.",
  "Johku account": "Johku-konto",
  "Johku agreement": "Johku-avtale",
  "Johku App": "Johku-appen",
  "Johku Hub isn't working right now. Try again in a moment.": "Johku Hub fungerer ikke akkurat nå. Prøv igjen om et øyeblikk.",
  "Johku Hub sign-in code: {code}": "Påloggingskode for Johku Hub: {code}",
  "Johku status: {title}": "Johku-status: {title}",
  "Kind of conversation": "Type samtale",
  "Know when things change": "Vit når noe endres",
  "Language": "Språk",
  "Let in {n}": "Slipp inn ({n})",
  "Let in: {n} seat": "Sluppet inn: {n} plass",
  "Let in: {n} seats": "Sluppet inn: {n} plasser",
  "Light off": "Slå av lyset",
  "Light on": "Slå på lyset",
  "Loading…": "Laster…",
  "Main menu": "Hovedmeny",
  "Maintenance": "Vedlikehold",
  "Make an offer": "Gi et tilbud",
  "Members of": "Medlemmer av",
  "Members' replies come as conversations of their own.": "Medlemmenes svar kommer som egne samtaler.",
  "Message": "Melding",
  "Message (optional)": "Melding (valgfritt)",
  "Message the seller about your order and get told when they reply.": "Send en melding til selgeren om bestillingen din, og bli varslet når de svarer.",
  "Message to {shop}": "Melding til {shop}",
  "Message to the shops": "Melding til butikkene",
  "Messages": "Meldinger",
  "Messages can't be reached right now.": "Meldingene kan ikke nås akkurat nå.",
  "My Johku": "Min Johku",
  "Name, sign-in and deleting the account": "Navn, pålogging og sletting av kontoen",
  "New conversation": "Ny samtale",
  "New incident": "Ny driftsforstyrrelse",
  "New message from {name} in Johku Hub": "Ny melding fra {name} i Johku Hub",
  "New message from {shop}": "Ny melding fra {shop}",
  "New message: {shop}, order {order}": "Ny melding: {shop}, bestilling {order}",
  "New messages in Johku Hub": "Nye meldinger i Johku Hub",
  "Next up": "Neste",
  "No connection. Check the connection and try again.": "Ingen tilkobling. Sjekk tilkoblingen og prøv igjen.",
  "No conversations yet": "Ingen samtaler ennå",
  "No conversations yet. Start one with the pen above.": "Ingen samtaler ennå. Start en med pennen ovenfor.",
  "No email? It can take a minute. Check the spam folder too.": "Ingen e-post? Det kan ta et minutt. Sjekk også søppelpostmappen.",
  "No incidents in the last 30 days.": "Ingen driftsforstyrrelser de siste 30 dagene.",
  "No matches.": "Ingen treff.",
  "No messages about this order yet. The customer gets an email with a link to the order page, where they can read and reply.": "Ingen meldinger om denne bestillingen ennå. Kunden får en e-post med en lenke til bestillingssiden, der de kan lese og svare.",
  "No messages yet": "Ingen meldinger ennå",
  "No messages yet.": "Ingen meldinger ennå.",
  "No shows match.": "Ingen forestillinger passer.",
  "No tickets start today for these.": "Ingen billetter starter i dag for disse.",
  "No valid codes": "Ingen gyldige koder",
  "None of the shop's collections has members yet.": "Ingen av butikkens samlinger har medlemmer ennå.",
  "Not a valid ticket": "Ikke en gyldig billett",
  "Not sent: {error}": "Ikke sendt: {error}",
  "Not shown yet": "Vises ikke ennå",
  "Not working": "Fungerer ikke",
  "Nothing matches “{query}”.": "Ingenting samsvarer med «{query}».",
  "Nothing to scan from today on.": "Ingenting å skanne fra i dag og fremover.",
  "Notice": "Melding",
  "Notifications are blocked for this site in the browser's settings.": "Varsler er blokkert for dette nettstedet i nettleserens innstillinger.",
  "Notifications are off for Johku Hub in the phone's settings.": "Varsler er slått av for Johku Hub i telefonens innstillinger.",
  "Notifications of new messages: {name}": "Varsler om nye meldinger: {name}",
  "Now": "Nå",
  "Offer a sales channel": "Tilby en salgskanal",
  "Offer: sell your products in {channel} with a {commission} % commission.": "Tilbud: selg produktene deres i {channel} med {commission} % provisjon.",
  "Offline": "Frakoblet",
  "Offline. {n} message will send when the connection returns.": "Frakoblet. {n} melding sendes når tilkoblingen er tilbake.",
  "Offline. {n} messages will send when the connection returns.": "Frakoblet. {n} meldinger sendes når tilkoblingen er tilbake.",
  "Offline. Messages will send when the connection returns.": "Frakoblet. Meldinger sendes når tilkoblingen er tilbake.",
  "Offline. These are the codes saved on this phone ({time}).": "Frakoblet. Dette er kodene som er lagret på denne telefonen ({time}).",
  "Offline. These are the orders saved on this phone.": "Frakoblet. Dette er bestillingene som er lagret på denne telefonen.",
  "Offline. These are the tickets saved on this phone ({time}).": "Frakoblet. Dette er billettene som er lagret på denne telefonen ({time}).",
  "OK": "OK",
  "One use": "Én bruk",
  "Only for {name}: check their ID.": "Kun for {name}: sjekk legitimasjonen.",
  "Only the shop's users who can use the POS can scan its tickets.": "Bare butikkens brukere med tilgang til kassen kan skanne billettene.",
  "Only your own sign-in: your shop and its Johku agreement are managed in Johku App.": "Bare din egen pålogging: butikken din og Johku-avtalen dens administreres i Johku App.",
  "Open Johku App": "Åpne Johku App",
  "Open the order": "Åpne bestillingen",
  "Open the order in the shop": "Åpne bestillingen i butikken",
  "Opening…": "Åpner…",
  "Opens in a new tab": "Åpnes i en ny fane",
  "Order": "Bestilling",
  "Order {id}": "Bestilling {id}",
  "Orders": "Bestillinger",
  "Other merchants": "Andre forhandlere",
  "Other merchants find {shop}": "Andre forhandlere finner {shop}",
  "Other orders": "Andre bestillinger",
  "Paid": "Betalt",
  "Partly working": "Fungerer delvis",
  "Pictures, PDF, text, Word and Excel files only": "Bare bilder, PDF-, tekst-, Word- og Excel-filer",
  "PIN code": "PIN-kode",
  "PIN codes": "PIN-koder",
  "Point the camera at a ticket's code.": "Rett kameraet mot billettens kode.",
  "Privacy policy": "Personvernerklæring",
  "Private message": "Privat melding",
  "Questions about your order? The shop's answer comes to Messages.": "Spørsmål om bestillingen din? Butikkens svar kommer i Meldinger.",
  "Read and reply: {url}": "Les og svar: {url}",
  "Read and search your conversations": "Lese og søke i samtalene dine",
  "Reader settings": "Leserinnstillinger",
  "Ready for the next ticket.": "Klar for neste billett.",
  "Recent": "Nylige",
  "Recipient": "Mottaker",
  "Refunded": "Refundert",
  "Reload": "Last inn på nytt",
  "Remove": "Fjern",
  "Reply in the Johku app or at {url}, signed in with this email address.": "Svar i Johku-appen eller på {url}, innlogget med denne e-postadressen.",
  "Resolved": "Løst",
  "Resolved: {title}": "Løst: {title}",
  "Resources": "Ressurser",
  "Row {row}, seat {seat}": "Rad {row}, sete {seat}",
  "Row {row}, seats {seats}": "Rad {row}, plasser {seats}",
  "Sales channel offer": "Tilbud om salgskanal",
  "Save": "Lagre",
  "Saved in Downloads": "Lagret i Nedlastinger",
  "Saving files needs Android 10 or newer": "Lagring av filer krever Android 10 eller nyere",
  "Scan a ticket with your scanner.": "Skann en billett med skanneren din.",
  "Scan for {n} show": "Skann for {n} forestilling",
  "Scan for {n} shows": "Skann for {n} forestillinger",
  "Scan for {n} start time": "Skann for {n} starttid",
  "Scan for {n} start times": "Skann for {n} starttider",
  "Scan tickets": "Skann billetter",
  "Search": "Søk",
  "Search by name": "Søk etter navn",
  "Search conversations": "Søk i samtaler",
  "Search shows": "Søk i forestillinger",
  "Seat": "Sete",
  "Seat {seat}": "Sete {seat}",
  "Seats {seats}": "Plasser {seats}",
  "See all": "Se alle",
  "Sell, check tickets and answer customers in Johku App.": "Selg, sjekk billetter og svar kunder i Johku App.",
  "Send": "Send",
  "Send as": "Send som",
  "Send code": "Send kode",
  "Send messages and start conversations as you": "Sende meldinger og starte samtaler på dine vegne",
  "Send now": "Send nå",
  "Send the offer": "Send tilbudet",
  "Send to members": "Send til medlemmer",
  "Send to shops": "Send til butikkene",
  "Send update": "Send oppdatering",
  "Sending…": "Sender…",
  "Sent to {done} of {n} people": "Sendt til {done} av {n} personer",
  "Sent to {done} of {n} person": "Sendt til {done} av {n} person",
  "Severity": "Alvorlighetsgrad",
  "Shop": "Butikk",
  "Show booking": "Vis reservasjonen",
  "Show conversations of": "Vis samtaler for",
  "Show more": "Vis mer",
  "Show orders of": "Vis bestillinger fra",
  "Show the code at the door.": "Vis koden ved inngangen.",
  "Show the code at the till, or type it in the shop's online store.": "Vis koden i kassen, eller skriv den inn i butikkens nettbutikk.",
  "Show tickets": "Vis billetter",
  "Show used and expired codes": "Vis brukte og utløpte koder",
  "Shows": "Forestillinger",
  "Sign in": "Logg inn",
  "Sign in again": "Logg inn på nytt",
  "Sign in to Johku Hub": "Logg inn på Johku Hub",
  "Sign in with an email code": "Logg inn med en e-postkode",
  "Sign in with Johku": "Logg inn med Johku",
  "Sign out": "Logg ut",
  "Sign out of {email}? Its messages are removed from this device.": "Logge ut av {email}? Meldingene fjernes fra denne enheten.",
  "Sign out of this account": "Logg ut av denne kontoen",
  "Sign out?": "Logge ut?",
  "Signing in with Johku didn't finish. Please try again.": "Innloggingen med Johku ble ikke fullført. Prøv igjen.",
  "Signing in with Johku didn't work ({error}).": "Innloggingen med Johku fungerte ikke ({error}).",
  "Signing in…": "Logger inn…",
  "So you see customers' questions right away": "Så du ser kundenes spørsmål med en gang",
  "Some shops didn't answer, so their codes may be missing: {shops}": "Noen butikker svarte ikke, så kodene deres kan mangle: {shops}",
  "Someone": "Noen",
  "Something went wrong.": "Noe gikk galt.",
  "Something went wrong. Please try again.": "Det oppstod en feil. Prøv på nytt.",
  "Something went wrong. Try again in a moment.": "Noe gikk galt. Prøv igjen om litt.",
  "Sounds": "Lyder",
  "Start the conversation": "Start samtalen",
  "Start times today": "Starttider i dag",
  "Status": "Status",
  "Subject (optional)": "Emne (valgfritt)",
  "Support": "Brukerstøtte",
  "Swipe for the next one": "Sveip for neste",
  "Switch camera": "Bytt kamera",
  "Switch shop": "Bytt butikk",
  "That code has expired. Ask for a new one.": "Den koden har utløpt. Be om en ny.",
  "That code isn't right. Check it and try again.": "Den koden er ikke riktig. Sjekk den og prøv igjen.",
  "That didn't go through. Try again in a moment.": "Det gikk ikke. Prøv igjen om litt.",
  "The booking isn't confirmed.": "Bestillingen er ikke bekreftet.",
  "The camera didn't start.": "Kameraet startet ikke.",
  "The code is on its way. Check again in a moment.": "Koden er på vei. Sjekk igjen om et øyeblikk.",
  "The conversation was declined.": "Samtalen ble avslått.",
  "The device's language": "Enhetens språk",
  "The download failed": "Nedlastingen mislyktes",
  "The file is larger than 20 MB": "Filen er større enn 20 MB",
  "The Johku team": "Johku-teamet",
  "The Johku team keeps you posted here until it's resolved.": "Johku-teamet holder deg oppdatert her til det er løst.",
  "The order page can't be opened right now. Try again in a moment.": "Bestillingssiden kan ikke åpnes akkurat nå. Prøv igjen om et øyeblikk.",
  "The PIN code and instructions show from {time}.": "PIN-koden og instruksjonene vises fra {time}.",
  "The shop can't be reached about this order from here. Try its order page.": "Butikken kan ikke nås om denne bestillingen herfra. Prøv bestillingens side.",
  "The ticket couldn't be confirmed. Scan it again.": "Billetten kunne ikke bekreftes. Skann den igjen.",
  "The ticket is for {what}.": "Billetten gjelder {what}.",
  "The ticket is for another place.": "Billetten gjelder et annet sted.",
  "The ticket is for another shop.": "Billetten tilhører en annen butikk.",
  "The ticket is for another show.": "Billetten gjelder en annen forestilling.",
  "The ticket is for another time.": "Billetten gjelder et annet tidspunkt.",
  "The tickets can't be opened right now. Try again in a moment.": "Billettene kan ikke åpnes akkurat nå. Prøv igjen om et øyeblikk.",
  "There's no one {name} can write to yet.": "Det er ingen {name} kan skrive til ennå.",
  "These tickets aren't available any more.": "Disse billettene er ikke lenger tilgjengelige.",
  "this account": "denne kontoen",
  "This browser can't read codes with the camera. Use the Johku Hub app, or a scanner (settings).": "Denne nettleseren kan ikke lese koder med kameraet. Bruk Johku Hub-appen eller en skanner (innstillinger).",
  "This device has no camera.": "Denne enheten har ikke kamera.",
  "This goes now to the staff of {n} shop, by push and email. Send it?": "Dette sendes nå til de ansatte i {n} butikk, som varsel og e-post. Sende?",
  "This goes now to the staff of {n} shops, by push and email. Send it?": "Dette sendes nå til de ansatte i {n} butikker, som varsel og e-post. Sende?",
  "This goes now to the staff of every shop, by push and email. Send it?": "Dette sendes nå til de ansatte i alle butikker, som varsel og e-post. Sende?",
  "This incident isn't shown any more.": "Denne driftsforstyrrelsen vises ikke lenger.",
  "This order has been cancelled. Its tickets aren't valid.": "Denne bestillingen er kansellert. Billettene er ikke gyldige.",
  "This order has been refunded. Its tickets aren't valid.": "Denne bestillingen er refundert. Billettene er ikke gyldige.",
  "Ticket": "Billett",
  "Ticket {n} of {total}": "Billett {n} av {total}",
  "Tickets": "Billetter",
  "Tickets at hand": "Billettene alltid med",
  "To (email)": "Til (e-post)",
  "To members": "Til medlemmer",
  "To the members of {collection}: {n} member": "Til medlemmene av {collection}: {n} medlem",
  "To the members of {collection}: {n} members": "Til medlemmene av {collection}: {n} medlemmer",
  "To the members of {collection}: sending, {sent}/{n}": "Til medlemmene av {collection}: sendes, {sent}/{n}",
  "Today": "I dag",
  "Tomorrow": "I morgen",
  "Total": "Totalt",
  "Try again": "Prøv igjen",
  "Turn on notifications": "Slå på varsler",
  "Unpaid": "Ubetalt",
  "Upcoming": "Kommende",
  "Update to the shops": "Oppdatering til butikkene",
  "Use a scanner instead of the camera": "Bruk en skanner i stedet for kameraet",
  "Use another address": "Bruk en annen adresse",
  "Used": "Brukt",
  "Uses": "Bruk",
  "Valid from {date}": "Gyldig fra {date}",
  "Valid until {date}": "Gyldig til {date}",
  "Validity": "Gyldighet",
  "Value left": "Gjenstående verdi",
  "Venue": "Sted",
  "Vibration": "Vibrering",
  "Waiting for {shop} to accept the conversation.": "Venter på at {shop} godtar samtalen.",
  "Waiting for an answer": "Venter på svar",
  "We'll email you a sign-in code. Use the address you use with Johku.": "Vi sender deg en påloggingskode på e-post. Bruk adressen du bruker hos Johku.",
  "What doesn't work, who it concerns, what to do meanwhile.": "Hva som ikke fungerer, hvem det gjelder og hva man kan gjøre i mellomtiden.",
  "What you offer, and what kind of partners you look for": "Hva dere tilbyr, og hvilke partnere dere ser etter",
  "What's wrong": "Hva er galt",
  "When": "Når",
  "When something in Johku doesn't work, and when it's fixed": "Når noe i Johku ikke fungerer, og når det er fikset",
  "When you buy from a Johku shop with {email}, the order appears here on its own.": "Når du handler i en Johku-butikk med {email}, vises bestillingen her av seg selv.",
  "When you buy from a Johku shop with your email, the order appears here on its own.": "Når du handler i en Johku-butikk med e-postadressen din, vises bestillingen her av seg selv.",
  "Whether other Johku merchants find your shop and can invite it to a conversation": "Om andre Johku-forhandlere finner butikken din og kan invitere den til en samtale",
  "With the customer": "Med kunden",
  "With your email, Google or Microsoft, as in Johku's online shops.": "Med e-post, Google eller Microsoft, som i Johkus nettbutikker.",
  "Withdraw the offer": "Trekk tilbake tilbudet",
  "Withdrawn": "Trukket tilbake",
  "Withdrew the offer.": "Trakk tilbake tilbudet.",
  "Write a message": "Skriv en melding",
  "Write to the customer": "Skriv til kunden",
  "Write to the shop": "Skriv til butikken",
  "Yesterday": "I går",
  "You": "Du",
  "You can close this page.": "Du kan lukke denne siden.",
  "You get this because you work for a shop on Johku. Follow the situation in the Johku app or at {url}.": "Du får dette fordi du jobber i en butikk som bruker Johku. Følg situasjonen i Johku-appen eller på {url}.",
  "You: ": "Du: ",
  "You'll see replies without opening the app.": "Du ser svar uten å åpne appen.",
  "You're offline. A new conversation needs a connection.": "Du er frakoblet. En ny samtale krever tilkobling.",
  "You're offline. Checking in and out needs a connection.": "Du er frakoblet. Inn- og utsjekking krever en tilkobling.",
  "You're offline. The first message needs a connection.": "Du er frakoblet. Den første meldingen krever tilkobling.",
  "You're offline. Try again when the connection returns.": "Ingen tilkobling. Prøv igjen når tilkoblingen er tilbake.",
  "You're staff at {shop}": "Du jobber i {shop}",
  "Your codes can't be loaded right now. Try again in a moment.": "Kodene kan ikke lastes akkurat nå. Prøv igjen om et øyeblikk.",
  "Your conversations with shops about your orders show up here.": "Samtalene dine med butikker om bestillingene dine vises her.",
  "Your Johku account doesn't have access to Johku Hub yet.": "Johku-kontoen din har ikke tilgang til Johku Hub ennå.",
  "Your Johku Hub sign-in code is {code}.": "Påloggingskoden din for Johku Hub er {code}.",
  "Your orders": "Bestillingene dine",
  "Your orders can't be loaded right now. Try again in a moment.": "Bestillingene kan ikke lastes akkurat nå. Prøv igjen om et øyeblikk.",
  "Your other accounts stay signed in.": "De andre kontoene dine forblir innlogget.",
  "Your other accounts stay signed in. Switch between them from your picture on Home.": "De andre kontoene dine forblir innlogget. Bytt mellom dem fra bildet ditt på Hjem.",
  "Your session for {account} has ended. Please sign in again.": "Økten din for {account} er avsluttet. Logg inn igjen.",
  "Your shop": "Butikken din",
  "Your shop has no sales channel in Johku. Set one up in the Johku app's settings first.": "Butikken din har ingen salgskanal i Johku. Opprett en først i innstillingene i Johku-appen.",
  "Your shops": "Butikkene dine",
  "Your tickets will show up here": "Billettene dine vises her",
  "Your tickets, orders and messages with shops": "Billettene, bestillingene og meldingene dine med butikker"
}
